import React from 'react';
import { useSelector } from 'react-redux';

import { Col, Modal, Row, Switch } from 'antd';

import { RootState } from '../../store';
import { EventActivityFilter } from './models';

export type EventSettingsModalProps = {
  updateListFilter: (filter: EventActivityFilter) => void;
  showSettingsModal: boolean;
  setShowSettingsModal: (show: boolean) => void;
};

const EventSettingsModal: React.FC<EventSettingsModalProps> = (props) => {
  const { userActivityEventsLoading } = useSelector((state: RootState) => state.userActivityEvents);

  return (
    <Modal title="Event Settings" open={props.showSettingsModal} onCancel={() => props.setShowSettingsModal(false)} footer={null} width={300}>
      <Row gutter={[8, 12]}>
        <Col span={20}>Show email events</Col>
        <Col span={4}>
          <Switch
            loading={userActivityEventsLoading}
            defaultChecked
            onChange={(checked) => {
              props.updateListFilter({ showHidden: checked });
            }}
          />
        </Col>

        <Col span={20}>Show text message events</Col>
        <Col span={4}>
          <Switch
            loading={userActivityEventsLoading}
            defaultChecked
            onChange={(checked) => {
              props.updateListFilter({ showTextMessage: checked });
            }}
          />
        </Col>

        <Col span={20}>Show manual note events</Col>
        <Col span={4}>
          <Switch
            loading={userActivityEventsLoading}
            defaultChecked
            onChange={(checked) => {
              props.updateListFilter({ showManualNote: checked });
            }}
          />
        </Col>

        <Col span={20}>Show download events</Col>
        <Col span={4}>
          <Switch
            loading={userActivityEventsLoading}
            defaultChecked
            onChange={(checked) => {
              props.updateListFilter({ showDownload: checked });
            }}
          />
        </Col>

        <Col span={20}>Show change events</Col>
        <Col span={4}>
          <Switch
            loading={userActivityEventsLoading}
            defaultChecked
            onChange={(checked) => {
              props.updateListFilter({ showChange: checked });
            }}
          />
        </Col>

        <Col span={20}>Show create events</Col>
        <Col span={4}>
          <Switch
            loading={userActivityEventsLoading}
            defaultChecked
            onChange={(checked) => {
              props.updateListFilter({ showCreate: checked });
            }}
          />
        </Col>

        <Col span={20}>Show delete events</Col>
        <Col span={4}>
          <Switch
            loading={userActivityEventsLoading}
            defaultChecked
            onChange={(checked) => {
              props.updateListFilter({ showDelete: checked });
            }}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default EventSettingsModal;
